import React from 'react';

// import { colors, defaultTextStyle } from 'settings/theme';

export default function Pill(props) {
    const {
        text,
        // onClick,
        // removeable = false,
        removeOnClick,
        style,
        ...restProps,
    } = props;

    return (
        <button
            className="button-skin-clear-selection"
            style={{
                ...style,
            }}
            onClick={removeOnClick}
            {...restProps}
        >
            {text}
        </button>
    );

    // WIP - we want to support adding an on-click to the X button and having a pill without an X but the UI library doesn't support it
    // return (
    //     <span
    //         style={{
    //             position: 'relative',
    //             paddingTop: 10,
    //             paddingRight: removeable ? 38 : 17,
    //             paddingBottom: 10,
    //             paddingLeft: 17,
    //             borderRadius: 17,
    //             border: `1px solid ${colors.border}`,
    //             height: 34,
    //         }}
    //         onClick={onClick}
    //     >
    //         <span
    //             style={{
    //                 ...defaultTextStyle,
    //                 fontSize: '15px',
    //                 wordBreak: 'keep-all',
    //             }}
    //         >
    //             {text}
    //         </span>
    //         {removeable &&
    //             <span
    //                 style={{
    //                     ...defaultTextStyle,
    //                     fontSize: '15px',

    //                     position: 'absolute',
    //                     top: 5,
    //                     rigth: 5,
    //                     border: `1px solid ${colors.border}`,
    //                     borderRadius: '50%',
    //                     height: 22,
    //                     width: 22,



    //                 }}
    //                 onClick={removeOnClick}
    //             >
    //                 X
    //             </span>
    //         }
    //     </span>
    // );
}


// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/Pill.js